import { useQuery } from '@tanstack/react-query';
import useInfrastructure from '../../useInfrastructure';
import { QueryKey } from '../../queryKeys';
import { Address, Zero } from 'nftx.js';
import { useNetwork } from '@nftx/react';
import { Tick } from '@/core/ticks';

const usePoolTicks = ({
  poolAddress,
  tickSpacing,
  tickIdxLowerBound,
  tickIdxUpperBound,
}: {
  poolAddress: Address | undefined;
  tickSpacing: number;
  tickIdxLowerBound: number;
  tickIdxUpperBound: number;
}) => {
  const network = useNetwork();
  const {
    pools: { fetchPoolTicks },
  } = useInfrastructure();
  const enabled = !!(
    network &&
    tickIdxLowerBound &&
    tickSpacing &&
    tickIdxUpperBound
  );

  return useQuery(
    [
      QueryKey.POOL_TICKS,
      network,
      poolAddress,
      tickIdxLowerBound,
      tickIdxUpperBound,
      tickSpacing,
    ],
    () => {
      if (poolAddress) {
        return fetchPoolTicks({
          network,
          poolAddress,
          tickIdxLowerBound,
          tickIdxUpperBound,
        });
      }

      const ticks: Tick[] = [];
      for (let x = tickIdxLowerBound; x < tickIdxUpperBound; x += tickSpacing) {
        ticks.push({
          index: `${x}`,
          liquidityGross: Zero,
          liquidityNet: Zero,
          prices: [Zero, Zero],
        });
      }
      return ticks;
    },
    { enabled }
  );
};

export default usePoolTicks;
